import {
  BarChartOutlined,
  CloseOutlined,
  CommentOutlined,
  DeleteColumnOutlined,
  DesktopOutlined,
  FileAddOutlined,
  FileFilled,
  FlagFilled,
  InfoCircleOutlined,
  RestOutlined,
  RocketOutlined,
  SaveOutlined,
  SearchOutlined,
  SendOutlined,
  StarFilled,
  SyncOutlined,
  UserDeleteOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { PageHeader } from "@ant-design/pro-components";
import BorderClearIcon from "@mui/icons-material/BorderClear";
import ControlCameraIcon from "@mui/icons-material/ControlCamera";
import MergeTypeIcon from "@mui/icons-material/MergeType";
import {
  Button,
  Drawer,
  Input,
  Modal,
  Popconfirm,
  Popover,
  QRCode,
  Segmented,
  Select,
  Skeleton,
  Statistic,
  Tag,
  Tooltip,
  message,
} from "antd";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import UserTypes from "../../Containers/Pages/RoadmapTypes/RoadmapTypes";
import CheckPermission from "../../Util/CheckPermission";
import { noteDefaultValue } from "../../Util/defaultValues";
import { normalizeUserNote } from "../../Util/autoNoteBuilder";
import api from "../../api/api";
import {
  defaultPsychologyRoadmapNote,
  defaultPsychologyRoadmapNoteEnd,
  defaultPsychologyRoadmapNoteStart,
  defaultRenewalRoadmapNoteEnd,
  defaultRenewalRoadmapNoteStart,
  defaultRoadmapNoteEnd,
  defaultRoadmapNoteStart,
} from "../../constants/defaultRoadmapNote";
import * as actions from "../../store/actions/action";
import AddNewTypeForm from "../AddNewTypeForm/AddNewTypeForm";
import Loading from "../Loading/Loading";
import SubFlagsModal from "../SubFlagsModal/SubFlagsModal";
import TextEditor from "../TextEditor/TextEditor";
import VoiceRecorder from "../VoiceRecorder/VoiceRecorder";
import styles from "./RoadmapControls.module.css";

const renderedNote = `<p class="ql-align-right ql-direction-rtl"><strong class="ql-size-large">نکات اپراتور</strong></p><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong class="ql-size-large">نکات مصاحبه</strong></p><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong class="ql-size-large">نکات سوپروایزر</strong></p><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><br></p><p class="ql-align-right ql-direction-rtl"><strong class="ql-size-large">ایجاد کارت‌های جدید</strong></p>`;
const renderedNote2 =
  '<p class="ql-direction-rtl ql-align-right"><strong class="ql-size-large">نکات اپراتور</strong></p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><strong class="ql-size-large">نکات مصاحبه</strong></p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><strong class="ql-size-large">نکات سوپروایزر</strong></p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><br></p><p class="ql-direction-rtl ql-align-right"><strong class="ql-size-large">ایجاد کارت‌های جدید</strong></p>';

const monthNames = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

const RoadmapControls = ({
  epollRecordId,
  isRenewal = false,
  exportedAdjectiveFromAnswers,
  exportedTypesFromAnswers,
  roadmapId,
  setTerms = () => {},
  limitRoadmapHandler,
  flagsPosBeforeDelete = [],
  importantAreas = [],
  exportedAutoNotes = [],
  checkHistory = (flagId) => {},
  conflictExistsInRoadmap = false,
  userTypeData,
  editigMode,
  resetFlagsList = (newTerms) => null,
  setEditingMode,
  setGlobalSearch,
  findFlag = (id) => ({}),
  insertAnswersFlagsToRoadmap,
  setNote,
  allRoadmapFlags = [],
  deletedFlags,
  setDeletedFlags,
  note,
  setRoadmapStatus,
  setAutoPublish,
  autoPublish,
  roadmapStatus,
  onSelectType,
  selectedType,
  setSelectedType,
  setUserNote,
  userNote,
  ensureUserNoteOnSave = () => {},
  markUserNoteSaved = () => {},
  hasSavedNote = false,
  LoadingSetter,
  ClearLoading,
  userData,
  globalSearch,
  roadmapKey,
  permissions,
  onReset,
  loading,
  isRoadmapChanged,
  setIsRoadmapChanged,
  isPublished,
  balanceButtonHandler,
  terms,
  skillTerms,
  setIsPublished,
  loadUserTerms,
  unGeneratorRemoveFlags,
  setTransparentMode,
  username,
  transparentMode,
  role,
  productCode,
  prevRoadmapKey,
  prevNoteForUser,
  userNoteVoiceUrl = null,
  setUserNoteVoiceUrl = () => {},
  getImportantAreasFn = () => [],
  onRemoveDuplicateImportantFlags = () => {},
}) => {
  const params = useParams();
  const [globalSearchOpen, setGlobalSearchOpen] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showUserNoteModal, setShowUserNoteModal] = useState(false);
  const [showNewTypeModal, setShowNewTypeModal] = useState(false);
  const [generatorUsed, setGeneratorUsed] = useState(false);
  const [showTypeModal, setShowTypeModal] = useState(false);
  const [tempSelectedType, setTempSelectedType] = useState();
  const [report, setReport] = useState({ flagsCount: 0, skillsCount: 0 });
  const [roadmapTypes, setRoadmapTypes] = useState();
  const [conflictModal, setConflictModal] = useState(false);
  const [typeData, setTypeData] = useState();
  const [autoNotes, setAutoNotes] = useState([]);
  const [selectionOrder, setSelectionOrder] = useState([]);

  const noteInputRef = useRef(null);
  const useNoteInputRef = useRef(null);
  const subFlagsRef = useRef(null);

  const previewLink = useMemo(() => {
    if (!roadmapKey) return null;
    return new URL(
      `app/roadmap/${roadmapKey}?preview=true`,
      process.env.REACT_APP_FRONTEND_BASEURL,
    ).href;
  }, [roadmapKey]);

  const mergedUsedBefore = useMemo(
    () =>
      [1, 2, 3, 4].some((e) => terms[`term${e}`].flags.some((e) => e.merged)),
    [terms],
  );

  const onRemoveType = () => {
    setSelectedType(null);
    setTypeData(null);
    changeTypeRequestHandler(null);
  };
  const getRoadmapTypes = (onFinish = () => {}) => {
    onFinish();
    // api.get("roadmaptypes").then((res) => {
    //   setRoadmapTypes(res.data);
    //   onFinish();
    // });
  };
  const saveRoadMap = () => {
    if (!isRoadmapChanged) {
      message.info("نقشه راه تغییر نکرده است.");
    }
    try {
      LoadingSetter();
      const roadmap = Object.keys(terms).map((key) => {
        return terms[key];
      });

      const { newFlagsHistory } = checkHistory();
      api
        .post("/roadmaps", {
          epollresponseId: epollRecordId ?? params.id,
          roadmap: {
            terms: roadmap,
            deletedFlags: deletedFlags ?? [],
            flagsPosBeforeDelete: flagsPosBeforeDelete ?? [],
            flagsHistory: newFlagsHistory ?? [],
          },
          roadmapTypeId: selectedType,
        })
        .then((res) => {
          // console.log(res);
          message.success("نقشه راه با موفقیت ذخیره شد.");
          ClearLoading();
        })
        .then(() => {
          setTimeout(() => {
            loadUserTerms();
          }, 1);
        })
        .catch((err) => {
          if (
            err instanceof TypeError &&
            err.message.includes("circular structure")
          ) {
            message.error("ایجاد لوپ در پیش نیاز - پس نیاز ها");
          }
          message.error("ذخیره نقشه راه با مشکل مواجه شد");
          console.log(err);
          ClearLoading();
        });
    } catch (err) {
      console.log(err);
    }
  };
  const saveSkillRoadMap = () => {
    LoadingSetter();
    const roadmap = Object.keys(skillTerms).map((key) => {
      const term = skillTerms[key];
      return {
        ...term,
        skills: Array.isArray(term.skills)
          ? term.skills.map((skill) => ({
              ...skill,
              flags: Array.isArray(skill.flags)
                ? skill.flags.map((f) =>
                    typeof f === "object" && f !== null ? f.id : f,
                  )
                : skill.flags,
            }))
          : term.skills,
      };
    });
    api
      .post("/roadmaps/saveskillroadmap", {
        epollresponseId: params.id,
        roadmap: { terms: roadmap },
      })
      .then((res) => {
        // console.log(res);
        message.success("نقشه راه مهارت با موفقیت ذخیره شد.");
        ClearLoading();
      })
      .catch((err) => {
        message.error("ذخیره نقشه مهارت راه با مشکل مواجه شد.");
        console.log(err);
        ClearLoading();
      });
  };
  const saveNote = () => {
    LoadingSetter();
    api
      .post("/roadmaps/note", {
        roadmapId: roadmapId,
        note: noteInputRef.current.value,
      })
      .then((res) => {
        message.success("یادداشت با موفقیت ذخیره شد.");
        ClearLoading();
        setNote(noteInputRef.current.value);
        setShowNoteModal(false);
      })
      .catch(() => {
        message.error("ذخیره یادداشت با مشکل مواجه شد.");
        ClearLoading();
      });
  };

  const saveButtonHandler = () => {
    switch (editigMode) {
      case "actions":
        saveRoadMap();
        break;
      case "skills":
        saveSkillRoadMap();
        break;
      default:
        saveRoadMap();
        saveSkillRoadMap();
    }
    ensureUserNoteOnSave();
    setIsRoadmapChanged(false);
  };
  const saveButtonPopUpHandler = () => {
    if (conflictExistsInRoadmap) {
      setConflictModal(true);
    } else {
      saveButtonHandler();
    }
  };
  const changeTypeRequestHandler = (roadmapTypeId) => {
    api
      .post("/roadmaps/update-roadmap-type", {
        epollresponseId: params.id,
        roadmapTypeId,
      })
      .then(() => message.success("تایپ با موفقیت تغییر کرد"))
      .catch(() => message.error("خطا در تغییر تایپ"));
  };
  const saveUserNote = () => {
    LoadingSetter();

    const note = normalizeUserNote(useNoteInputRef.current.value);
    api
      .post("/roadmaps/usernote", {
        roadmapId: roadmapId,
        note,
        voiceUrl: userNoteVoiceUrl ?? null,
      })
      .then((res) => {
        message.success("یادداشت برای کاربر با موفقیت ذخیره شد.");
        setUserNote(note);
        markUserNoteSaved();
        ClearLoading();
        setShowUserNoteModal(false);
      })
      .catch(() => {
        message.error("ذخیره یادداشت برای کاربر با مشکل مواجه شد.");
        ClearLoading();
      });
  };
  const publish = () => {
    LoadingSetter();
    let isRoadmapEmpty = true;
    Object.keys(terms).forEach((term) => {
      if (terms[term].flags.length !== 0) {
        isRoadmapEmpty = false;
      }
    });
    if (isRoadmapEmpty) {
      message.error("شما هیچ کارتی به کاربر اختصاص نداده‌اید.");
      ClearLoading();
      return;
    }
    api
      .post("/roadmaps/publish", { epollresponseId: params.id })
      .then(() => {
        saveRoadMap();
      })
      .then(() => {
        ClearLoading();
        message.success("نقشه راه منتشر شد.");
        setIsPublished(true);
      })
      .catch(() => {
        ClearLoading();
        message.error("انتشار نقشه راه با مشکل مواجه شد.");
      });
  };
  const unPublish = () => {
    LoadingSetter();
    api
      .post("/roadmaps/unpublish", { epollresponseId: params.id })
      .then(() => {
        ClearLoading();
        message.success("عدم انتشار نقشه راه با موفقیت انجام شد.");
        setIsPublished(null);
      })
      .catch(() => {
        ClearLoading();
        message.error("عدم انتشار نقشه راه با مشکل مواجه شد.");
      });
  };
  const roadmapStatusChangerHandler = (status) => {
    if (status === "COMPLETED") saveButtonHandler();

    setRoadmapStatus(status);
    api
      .patch(`/roadmaps/change-status`, { status, key: roadmapKey ?? "" })
      .then(() => message.success("وضعیت با موفقیت تغییر کرد"))
      .catch(() => message.error("خطا در تغییر وضعیت"));
  };

  const calculateReports = () => {
    let flagsCount = 0;
    let skillsCount = 0;

    Object.keys(terms).forEach((key) => {
      flagsCount += terms[key].flags.filter((flag) => !flag?.hidden).length;
    });
    Object.keys(skillTerms).forEach((key) => {
      skillsCount += skillTerms[key].skills.length;
    });
    setReport({ flagsCount, skillsCount });
  };

  const autoPublishToggleHandler = () => {
    saveButtonHandler();
    const newPublishStat = !autoPublish;
    setAutoPublish(newPublishStat);
    api
      .post("/roadmaps/auto-publish", {
        key: roadmapKey,
        autoPublish: newPublishStat,
      })
      .then(() => {})
      .catch(() => {
        setAutoPublish(!newPublishStat);
        message.error("ثبت انتشار اتوماتیک با خطا مواجه شد");
      });
  };

  useEffect(() => {
    calculateReports();
  }, [terms]);

  const handleChange = (values) => {
    // If a new value is added (selection)
    let finalArr = [...values];
    if (values.length > selectedAutoNoteValues.length) {
      const newValue = values.find((v) => !selectedAutoNoteValues.includes(v));
      finalArr = [...selectionOrder, newValue];
      setSelectionOrder(finalArr);
    }
    // If a value is removed (deselection)
    if (values.length < selectedAutoNoteValues.length) {
      const removedValue = selectedAutoNoteValues.find(
        (v) => !values.includes(v),
      );
      finalArr = selectionOrder.filter((v) => v !== removedValue);
      setSelectionOrder(finalArr);
    }

    const sortedValues = values.sort((a, b) => {
      const indexA = finalArr.indexOf(a);
      const indexB = finalArr.indexOf(b);
      return indexA - indexB;
    });

    const noteStart =
      productCode === "roadmap-psychology"
        ? defaultPsychologyRoadmapNoteStart.replace("%name%", username)
        : (isRenewal
            ? defaultRenewalRoadmapNoteStart
            : defaultRoadmapNoteStart
          ).replace("%name%", username);
    const noteEnd =
      productCode === "roadmap-psychology"
        ? defaultPsychologyRoadmapNoteEnd
        : isRenewal
          ? defaultRenewalRoadmapNoteEnd
          : defaultRoadmapNoteEnd;
    const autoNoteSpans = [
      ...exportedAutoNotes
        .filter((e) => values.includes(e.value))
        ?.map((e) => `<span style="color: rgb(230, 0, 0);">${e.value}</span>`),
      ...sortedValues
        .filter((e) => !exportedAutoNotes.find((el) => el.value.trim() === e))
        ?.map((e) => `<span style="color: rgb(230, 0, 0);">${e}</span>`),
    ];
    setUserNote(
      `${noteStart}<br>${
        autoNoteSpans.length ? `${autoNoteSpans.join(" ")}<br>` : ""
      }${noteEnd}`
        .replace(/(<\/p>\s*(?:<\/[a-z][a-z0-9]*>\s*)*)<br\s*\/?>/gi, "$1")
        .replace(
          /<br\s*\/?>\s*((?:<[a-z][a-z0-9]*(?:\s[^>]*)?>\s*)*<p[\s>])/gi,
          "$1",
        )
        .replace(/(?:<br\s*\/?>\s*){2,}/gi, "<br>")
        .replace(/(?:\s*<br\s*\/?>)+\s*$/gi, "")
        .trim(),
    );
    // productCode === "psychology";
  };

  const roadmapChanger = (
    <Segmented
      style={{ direction: "ltr" }}
      value={editigMode}
      onChange={(val) => {
        setEditingMode(val);
      }}
      options={[
        { value: "actions", label: "نقشه راه فعالیت" },
        { value: "skills", label: "نقشه راه مهارت" },
      ]}
    />
  );
  const searchButton = (
    <Popover
      onOpenChange={(open) => {
        setGlobalSearchOpen(open);
      }}
      open={globalSearchOpen}
      trigger="click"
      title="جستجو"
      content={
        <>
          <Input
            onBlur={(e) => {
              setGlobalSearch(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                setGlobalSearch(e.target.value);
              }
            }}
          />
          <Button
            style={{ marginTop: "0.5rem" }}
            type="primary"
            onClick={() => {
              setGlobalSearchOpen(false);
            }}
          >
            جستجو
          </Button>
          <Button
            style={{ marginTop: "0.5rem", marginRight: "0.5rem" }}
            onClick={() => {
              setGlobalSearch("");
              setGlobalSearchOpen(false);
            }}
          >
            حذف
          </Button>
        </>
      }
    >
      <Tooltip title="جستجو">
        <Button
          icon={<SearchOutlined />}
          type={
            globalSearch
              ? `${globalSearch}`.trim() !== ""
                ? "primary"
                : "default"
              : "default"
          }
          onClick={() => {
            setGlobalSearchOpen(!globalSearchOpen);
          }}
        />
      </Tooltip>
    </Popover>
  );

  const roadmapBuilderButton = (
    <Tooltip title=" ساخت نقشه راه">
      <Button
        type={generatorUsed ? "primary" : "default"}
        disabled={roadmapId ? false : true}
        onClick={() => {
          if (generatorUsed) {
            unGeneratorRemoveFlags();
          } else {
            const termsClone = insertAnswersFlagsToRoadmap();
            setTimeout(() => {
              makeNewType(termsClone);
            }, 5000);
          }
          setGeneratorUsed((value) => !value);
        }}
        icon={<RocketOutlined />}
      />
    </Tooltip>
  );
  const limitRoadmapButton = (
    <Tooltip title="قیچی">
      <Button
        type={deletedFlags?.length > 0 ? "primary" : "default"}
        disabled={roadmapId ? false : true}
        onClick={limitRoadmapHandler}
        icon={<DeleteColumnOutlined />}
      />
    </Tooltip>
  );
  const balanceTerms = (
    <Tooltip title="تعادل نقشه راه">
      <Button
        type={"default"}
        disabled={roadmapId ? false : true}
        onClick={balanceButtonHandler}
        icon={<ControlCameraIcon fontSize="small" />}
      />
    </Tooltip>
  );
  const removeDuplicateImportanceButton = isRenewal ? (
    <Tooltip title="حذف اهمیت‌های تکراری ۲ و ۳">
      <Button
        type={"default"}
        disabled={roadmapId ? false : true}
        onClick={onRemoveDuplicateImportantFlags}
      >
        حذف اهمیت‌های تکراری
      </Button>
    </Tooltip>
  ) : null;
  const transparentButton = (
    <Tooltip title="نمایش تغییرات جنریتور">
      <Button
        type={transparentMode ? "primary" : "default"}
        disabled={roadmapId ? false : true}
        onClick={() => setTransparentMode((p) => !p)}
        icon={<BorderClearIcon />}
      />
    </Tooltip>
  );

  const getAreas = () => {
    const report = {};
    [
      ...terms?.term1?.flags,
      ...terms?.term2?.flags,
      ...terms?.term3?.flags,
      ...terms?.term4?.flags,
    ].forEach((fl) => {
      if (!report[fl.type]) {
        report[fl.type] = 1;
      }

      report[fl.type] = report[fl.type] + 1;
    });

    return Object.keys(report)
      .map((e) => ({ name: e, count: report[e] }))
      .sort((a, b) => b.count - a.count)
      .map((e) => e.name);
  };

  // auto type Start
  const getRoadmapPeriod = (cloneTerm = terms) => {
    const term1 = (cloneTerm?.term1?.title ?? "")?.split(" و ")?.at(0)?.trim();
    const term4 = (cloneTerm?.term4?.title ?? "")?.split(" و ")?.at(1)?.trim();

    const isTerm1MonthName = monthNames.find((el) => el === term1);
    const isTerm4MonthName = monthNames.find((el) => el === term4);

    if (!isTerm1MonthName || !isTerm4MonthName) return;

    return [`${term1} تا ${term4}`];
  };

  // const makeNewType = (termsCl) => {
  //   api
  //     .post("roadmaptypes", {
  //       tag: Array.from(new Set([...exportedAdjectiveFromAnswers])),
  //       period: getRoadmapPeriod(termsCl),
  //       ...(userTypeData?.gender
  //         ? { gender: userTypeData?.gender === "آقا" ? "man" : "woman" }
  //         : {}),
  //       ...(userTypeData?.age ? { age: userTypeData?.age } : {}),
  //       types: exportedTypesFromAnswers ?? [],
  //       flagsRoadmap: termsCl,
  //       product: productCode,
  //       // area: getAreas(),
  //       area: importantAreas.map((e) => e.area),
  //     })
  //     .then((res) => {
  //       changeTypeRequestHandler(res.data.id);
  //       setSelectedType(res.data.id);
  //       message.success("تایپ با موفقیت ساخته شد");
  //     });
  // };
  // auto type end

  const makeNewType = useCallback(
    (termsCl) => {
      api
        .post("roadmaptypes", {
          tag: Array.from(new Set([...exportedAdjectiveFromAnswers])),
          period: getRoadmapPeriod(termsCl),
          ...(userTypeData?.gender
            ? { gender: userTypeData?.gender === "آقا" ? "man" : "woman" }
            : {}),
          ...(userTypeData?.age ? { age: userTypeData?.age } : {}),
          types: exportedTypesFromAnswers ?? [],
          flagsRoadmap: termsCl,
          product: productCode,
          area: getImportantAreasFn(termsCl).map((e) => e.area),
        })
        .then((res) => {
          changeTypeRequestHandler(res.data.id);
          setSelectedType(res.data.id);
          message.success("تایپ با موفقیت ساخته شد");
        });
    },
    [
      exportedAdjectiveFromAnswers,
      getRoadmapPeriod,
      userTypeData,
      exportedTypesFromAnswers,
      productCode,
      importantAreas,
    ],
  );

  const noteButton = (
    <Tooltip title="یادداشت">
      <Button
        type={
          note !== noteDefaultValue &&
          note !== renderedNote &&
          note !== renderedNote2
            ? "primary"
            : "default"
        }
        disabled={roadmapId ? false : true}
        onClick={() => {
          setShowNoteModal(true);
          window.setTimeout(() => {
            setNote(note + " ");
          }, 10);
        }}
        icon={<InfoCircleOutlined />}
      />
    </Tooltip>
  );
  const userNoteButton = (
    <Tooltip title="نظر کارشناس">
      <Button
        disabled={roadmapId ? false : true}
        icon={<CommentOutlined />}
        onClick={() => {
          setShowUserNoteModal(true);
          window.setTimeout(() => {
            setUserNote(userNote + " ");
          }, 10);
        }}
      />
    </Tooltip>
  );
  const addNewTypeButton = (
    <Tooltip title={!selectedType ? "ساخت تایپ جدید" : "ویرایش تایپ"}>
      <Button
        disabled={roadmapId ? false : true}
        icon={!selectedType ? <FileAddOutlined /> : <FileFilled />}
        onClick={() => setShowNewTypeModal(true)}
      />
    </Tooltip>
  );
  const typesListSelect = (
    <>
      {selectedType && (
        <Tooltip title="حذف تایپ">
          <Button
            disabled={roadmapId ? false : true}
            icon={<UserDeleteOutlined />}
            onClick={onRemoveType}
            danger
          />
        </Tooltip>
      )}
      <Select
        value={selectedType}
        disabled={roadmapId ? false : true}
        placeholder="انتخاب تایپ"
        onClick={() => setShowTypeModal(true)}
        onChange={(value) => {
          const selectedType = roadmapTypes.find((t) => t.id === value);
          if (selectedType) {
            onSelectType(selectedType);
            changeTypeRequestHandler(selectedType.id);
          }
        }}
      >
        {Array.isArray(roadmapTypes) &&
          roadmapTypes.map((type) => {
            return <Select.Option value={type.id}>{type.title}</Select.Option>;
          })}
      </Select>
    </>
  );
  const subFlagsButton = (
    <Tooltip title="ادغام کارت ها">
      <Button
        type={mergedUsedBefore ? "primary" : "default"} // default
        onClick={() => {
          subFlagsRef?.current?.toggleShow();
        }}
        icon={<MergeTypeIcon />}
      />
    </Tooltip>
  );

  useEffect(() => {
    console.log({ roadmapTypes });
  }, [roadmapTypes]);

  const roadmapStatusChanger = (
    <Select
      value={roadmapStatus}
      disabled={roadmapId ? false : true}
      placeholder="انتخاب تایپ"
      onChange={roadmapStatusChangerHandler}
    >
      <Select.Option value="UN_COMPLETED">تکمیل نشده</Select.Option>
      <Select.Option value="COMPLETED">تکمیل شده</Select.Option>
      <Select.Option value="SUPERVISOR_CHECK">چک سوپروایزر</Select.Option>
    </Select>
  );
  const previewButton = (
    <Tooltip title="پیش نمایش">
      <a href={previewLink} target="_blank" rel="noopener noreferrer">
        <Button
          loading={roadmapKey ? false : true}
          disabled={roadmapKey ? false : true}
          icon={<DesktopOutlined />}
        />
      </a>
    </Tooltip>
  );
  const reportButton = (
    <Popover
      trigger="click"
      onOpenChange={() => {
        calculateReports();
      }}
      content={
        <>
          <Statistic
            title="تعداد کارت‌ها"
            prefix={<FlagFilled style={{ width: "1rem" }} />}
            value={report.flagsCount}
          />
          <Statistic
            title="تعداد مهارت‌ها"
            prefix={<StarFilled style={{ width: "1rem" }} />}
            value={report.skillsCount}
          />
        </>
      }
    >
      <Tooltip title="گزارش">
        <Button
          type={report.flagsCount > 40 ? "primary" : "default"}
          loading={roadmapKey ? false : true}
          disabled={roadmapKey ? false : true}
          icon={<BarChartOutlined />}
        />
      </Tooltip>
    </Popover>
  );

  const getAutoNotes = useCallback(
    async () =>
      await api
        .get("/auto-note")
        .then((res) => {
          setAutoNotes(res.data);
        })
        .catch(() => message.error("خطا در دریافت نظر کارشناس اتومات")),
    [],
  );

  const autoPublishButton = CheckPermission(
    "roadmaps_publish",
    permissions,
  ) && (
    <Popconfirm
      onConfirm={autoPublishToggleHandler}
      title={
        !autoPublish
          ? "آیا از انتشار اتوماتیک نقشه راه مطمئن هستید؟"
          : "آیا از لغو انتشار اتوماتیک نقشه راه مطمئن هستید؟"
      }
    >
      <Button danger={autoPublish}>
        {autoPublish ? "لغو انتشار اتومات" : "انتشار اتومات"}
      </Button>
    </Popconfirm>
  );
  const publishButton = CheckPermission("roadmaps_publish", permissions) && (
    <Popconfirm
      onConfirm={() => {
        unPublish();
      }}
      title="آیا از عدم انتشار نقشه راه مطمئن هستید؟"
    >
      <Button icon={<CloseOutlined />} danger type="primary">
        عدم انتشار
      </Button>
    </Popconfirm>
  );
  const unPublishButton = CheckPermission("roadmaps_publish", permissions) && (
    <Popconfirm
      onConfirm={() => {
        publish();
      }}
      title="آیا از انتشار نقشه راه مطمئن هستید؟"
    >
      <Button disabled={roadmapId ? false : true} icon={<SendOutlined />}>
        انتشار
      </Button>
    </Popconfirm>
  );
  const saveButton = (
    <Button
      icon={<SaveOutlined />}
      loading={loading}
      type="primary"
      style={{ backgroundColor: "green" }}
      className={[isRoadmapChanged ? styles.FlashingSaveButton : null].join(
        " ",
      )}
      disabled={roadmapId ? false : true}
      // onClick={saveButtonHandler}
      onClick={saveButtonPopUpHandler}
    >
      ذخیره
    </Button>
  );
  const resetButton = (
    <Popconfirm
      onConfirm={() => {
        onReset();
      }}
      title="آیا از پاک کردن همه کارت‌ها و مهارت‌های نقشه راه مطمئن هستید؟"
    >
      <Button
        icon={<RestOutlined />}
        danger
        disabled={roadmapId ? false : true}
      />
    </Popconfirm>
  );

  useEffect(() => {
    if (terms && !generatorUsed) {
      let isGeneratedFlag = false;
      Object.keys(terms)?.forEach((key) => {
        if (!isGeneratedFlag) {
          terms[key].flags.forEach((flag) => {
            if (flag.autoGenerated) {
              isGeneratedFlag = true;
            }
          });
        }
      });
      if (isGeneratedFlag) {
        setGeneratorUsed(true);
      }
    }
  }, [terms, generatorUsed]);

  useEffect(() => {
    if (Array.isArray(roadmapTypes)) {
      if (selectedType) {
        roadmapTypes.forEach((type) => {
          if (type.id === selectedType) {
            setTypeData(type);
          }
        });
      } else {
        setTypeData(null);
      }
    }
  }, [selectedType, roadmapTypes]);

  const loadType = (id) => {
    api.get(`/roadmaptypes/${id}`).then((res) => {
      const { flagsRoadmap, ...other } = res.data;
      setRoadmapTypes([other]);
    });
  };

  useEffect(() => {
    if (selectedType) loadType(selectedType);
  }, [selectedType]);

  useEffect(() => {
    getRoadmapTypes();
    getAutoNotes();
  }, []);

  const selectedAutoNoteValues = useMemo(() => {
    const strip = (s) =>
      String(s || "")
        .replace(/<[^>]*>/g, "")
        .trim();

    const matchesNote = (note, text) => {
      return text.includes(strip(note.value));
    };

    return autoNotes
      .filter((note) => matchesNote(note, strip(userNote)))
      .sort((a, b) => a.priority - b.priority);
  }, [autoNotes, userNote]);

  useEffect(() => {
    if (!productCode) return;
    if (hasSavedNote) return;
    const notes = autoNotes.filter(
      (e1) =>
        e1.typeTags.length > 0 &&
        e1.typeTags?.every((adj) => exportedAdjectiveFromAnswers.includes(adj)),
    );

    const finalNotes = [];
    for (let index = 1; index <= 10; index++) {
      if (finalNotes.length >= 3) break;
      finalNotes.push(...notes.filter((e) => e.priority == index));
    }

    handleChange([...finalNotes.map((e) => e.value)]);
  }, [autoNotes, exportedAdjectiveFromAnswers, productCode, username, hasSavedNote]);

  return (
    <>
      <PageHeader
        title={
          userData ? (
            <>
              {userData.first_name + " " + userData.last_name}
              {prevRoadmapKey && (
                <Tooltip title="مشاهده نقشه‌راه قبلی">
                  <Link
                    to={`/user-roadmap/${prevRoadmapKey}`}
                    style={{ marginRight: 8 }}
                  >
                    <SyncOutlined style={{ color: "#1890ff", fontSize: 16 }} />
                  </Link>
                </Tooltip>
              )}
            </>
          ) : (
            <Skeleton.Input active />
          )
        }
        avatar={{ icon: <UserOutlined />, size: "large" }}
        subTitle={
          CheckPermission("show_phone_number", permissions)
            ? `( ${userData?.mobile} )`
            : ""
        }
        extra={
          <>
            {resetButton}
            {reportButton}
            {roadmapChanger}
            {addNewTypeButton}
            {typesListSelect}
            {roadmapStatusChanger}
            {searchButton}
            {editigMode === "actions" && roadmapBuilderButton}
            {limitRoadmapButton}
            {removeDuplicateImportanceButton}
            {balanceTerms}
            {subFlagsButton}
            {transparentButton}
            {noteButton}
            {userNoteButton}
            {previewButton}
            {roadmapStatus === "COMPLETED" && autoPublishButton}
            {isPublished ? publishButton : unPublishButton}
            {saveButton}
          </>
        }
      />
      <Drawer
        placement="left"
        title="یادداشت‌ها"
        width="50rem"
        open={showNoteModal}
        mask={false}
        style={{ position: "relative", overflow: "hidden" }}
        onClose={() => saveNote()}
      >
        {loading && <Loading saving />}
        <TextEditor value={note ? note : noteDefaultValue} ref={noteInputRef} />
      </Drawer>

      {/* experts note */}
      {showUserNoteModal && (
        <Drawer
          placement="left"
          title="نظر کارشناس"
          width="50rem"
          mask={false}
          open={showUserNoteModal}
          onClose={() => saveUserNote()}
          style={{ position: "relative", overflow: "hidden" }}
        >
          <Select
            mode="multiple"
            allowClear
            showSearch
            style={{ width: "100%", marginBottom: "1rem" }}
            placeholder="تگ نظر کارشناس اتومات "
            value={selectedAutoNoteValues}
            onChange={handleChange}
            filterOption={(search, item) => {
              return item?.label?.props?.children?.includes(search);
            }}
            tagRender={(props) => {
              const { label, value, closable, onClose } = props;
              const isAutomatic = exportedAutoNotes.some(
                (e) => e.value.trim() === value,
              );
              return (
                <Tag
                  closable={closable}
                  onClose={onClose}
                  color={isAutomatic ? undefined : "red"}
                  style={{ marginInlineEnd: 4 }}
                >
                  {label}
                </Tag>
              );
            }}
            options={autoNotes.map((e) => ({
              label: (
                <Tooltip
                  title={
                    <span dangerouslySetInnerHTML={{ __html: e.value }}></span>
                  }
                >
                  {e.title}
                </Tooltip>
              ),
              value: e.value,
            }))}
          />

          {loading && <Loading saving />}
          <div style={{ maxHeight: "40vh", overflow: "auto" }}>
            <style>{`.ql-editor { min-height: 5rem !important; }`}</style>
            <TextEditor
              value={normalizeUserNote(userNote)}
              ref={useNoteInputRef}
            />
          </div>
          <div
            style={{
              marginTop: "1rem",
              padding: "0.75rem",
              border: "1px solid #d9d9d9",
              borderRadius: "4px",
            }}
          >
            <div style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
              صدای یادداشت برای کاربر
            </div>
            <VoiceRecorder
              key={`usernote-voice-${userNoteVoiceUrl || "empty"}`}
              initialMedia={userNoteVoiceUrl ? { url: userNoteVoiceUrl } : null}
              onChange={(field, value) => {
                if (field !== "voiceUrl") return;
                setUserNoteVoiceUrl(value || null);
              }}
            />
          </div>
          {prevNoteForUser && (
            <div style={{ marginTop: "1rem" }}>
              <style>{`.prevNoteForUserPreview p{margin:0}.prevNoteForUserPreview br+br{display:none}`}</style>
              <div style={{ marginBottom: "0.5rem", fontWeight: "bold" }}>
                نظر کارشناس نقشه‌راه قبلی:
              </div>
              <div
                className="prevNoteForUserPreview"
                style={{
                  padding: "1rem",
                  backgroundColor: "#f5f5f5",
                  border: "1px solid #d9d9d9",
                  borderRadius: "4px",
                  opacity: 0.7,
                  pointerEvents: "none",
                  direction: "rtl",
                }}
                dangerouslySetInnerHTML={{
                  __html: normalizeUserNote(prevNoteForUser),
                }}
              />
            </div>
          )}
        </Drawer>
      )}

      <SubFlagsModal
        resetFlagsList={resetFlagsList}
        terms={terms}
        setTerms={setTerms}
        findFlag={findFlag}
        allRoadmapFlags={allRoadmapFlags}
        ref={subFlagsRef}
      />

      {/* type creator */}
      <Drawer
        placement="right"
        title={!selectedType ? "ساخت تایپ جدید" : "ویرایش تایپ"}
        width="50rem"
        open={showNewTypeModal}
        onClose={() => {
          setShowNewTypeModal(false);
        }}
      >
        <AddNewTypeForm
          loadType={loadType}
          isEditing={selectedType ? true : false}
          importantAreas={importantAreas}
          exportedAdjectiveFromAnswers={exportedAdjectiveFromAnswers}
          exportedTypesFromAnswers={exportedTypesFromAnswers}
          productCode={productCode}
          userTypeData={userTypeData}
          roadmap={terms}
          formData={typeData}
          onEdit={(typeId, newData) => {
            setShowNewTypeModal(false);
            const typesClone = structuredClone(roadmapTypes);
            const newTypes = typesClone.map((el) => {
              if (`${typeId}` === `${el.id}`) {
                return newData;
              }
              return el;
            });
            setRoadmapTypes(newTypes);
          }}
          onFinish={(typeId) => {
            getRoadmapTypes(() => {
              setShowNewTypeModal(false);
              setSelectedType(typeId);
              changeTypeRequestHandler(typeId);
            });
          }}
        />
      </Drawer>

      <Modal
        width="100%"
        centered
        open={showTypeModal}
        destroyOnClose
        footer={null}
        onCancel={() => {
          setShowTypeModal(false);
        }}
      >
        <UserTypes
          rowSelection={{
            hideSelectAll: true,
            type: "radio",
            selectedRowKeys: tempSelectedType,
            onChange: (selectedKeys) => {
              if (selectedKeys?.at(0)) {
                changeTypeRequestHandler(selectedKeys?.at(0));
                setSelectedType(selectedKeys?.at(0));
                setShowTypeModal(false);
              }
              setTempSelectedType(selectedKeys);
            },
          }}
        />
      </Modal>

      {/* coflict err modal */}
      <Modal
        centered
        title="آیا از ذخیره همراه با تعارض ها مطمئن هستید؟"
        open={conflictModal}
        destroyOnClose
        onCancel={() => {
          setConflictModal(false);
        }}
        onOk={() => {
          setConflictModal(false);
          saveButtonHandler();
        }}
      ></Modal>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
    operatorData: state.userData,
    role: state.userData ? state.userData.role : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(RoadmapControls));
